<template>
  <div class="theme-input hrm_input">
    <label
      class="hrm_input_label text-sm font-medium text-gray-800 dark:text-gray-400"
      >{{ trans("lang.labels.data_provider_type") }}
    </label>
    <div class="relative mt-2">
      <VueMultiselect
        :key="componentKey"
        class="hrm-vuemultiselect"
        v-model="filterData[filterItem.DataProviderType]"
        @clear="onClearDataProviderType"
        :options="filterItem.dataProviderTypes"
        @select="onChangeDataProviderType"
        :placeholder="trans('lang.labels.Select')"
        label="name"
        valueProp="id"
        :searchable="true"
      />
    </div>
  </div>
  <div class="hrm_input">
    <label
      class="hrm_input_label text-sm font-medium text-gray-800 dark:text-gray-400"
      >{{ trans("lang.labels.data_provider") }}
    </label>
    <div class="relative mt-2">
      <VueMultiselect
        :key="componentDataKey"
        class="hrm-vuemultiselect hrm_input_field"
        v-model="filterData[filterItem.DataProvider]"
        :options="filterItem.dataProviders"
        @clear="onClearDataProvider"
        :placeholder="trans('lang.labels.Select')"
        label="name"
        valueProp="id"
        :searchable="true"
      />
    </div>
  </div>
</template>
<script setup>
import { onMounted, ref } from "vue";
import VueMultiselect from "@vueform/multiselect";
import { trans } from "@/helpers";

const props = defineProps({
  filterItem: { type: Object },
  filterData: { type: Object, required: true },
});

const componentKey = ref(1);
const componentDataKey = ref(1);

const onChangeDataProviderType = async () => {
  const value = props.filterData[props.filterItem.DataProviderType];

  if (value === "others") {
    sourcesData("datacenter.interview-sources.index");
  } else if (value === "employee") {
    sourcesData("employee-management.employees.index");
  } else {
    await getDataProvider(value);
  }
  onClearDataProvider()
  componentDataKey.value += 1;
};

const onClearDataProviderType = () => {
  props.filterData[props.filterItem.DataProvider] = null;
  props.filterData[props.filterItem.DataProviderType] = null;
  props.filterItem.dataProviders = [];
  componentKey.value += 1;
  componentDataKey.value += 1;
};

const onClearDataProvider = () => {
  props.filterData[props.filterItem.DataProvider] = null;
};

const getDataProvider = async (value) => {
  try {
    let query = {
      perPage: "all",
      status: 1,
    };

    const response = await axios.get(
      route("datacenter.dataProviders.index", {
        data_provider_type_id: value,
      }),
      { params: query }
    );

    props.filterItem.dataProviders = [...response.data.data];
  } catch (error) {
    console.error("Error fetching work sources:", error);
  }
};

const getDataProvierType = async () => {
  try {
    const response = await axios.get(
      route("datacenter.data-provider-types.index")
    );
    const data = [
      {
        name: trans("lang.labels.employee_reference"),
        id: "employee",
      },
      { name: trans("lang.labels.Other"), id: "others" },
    ];
    props.filterItem.dataProviderTypes = [...response.data.data, ...data];
  } catch (error) {
    console.error("Error fetching work sources profiles:", error);
  }
};
const sourcesData = async ($route) => {
  let allData = {
    perPage: "all",
    status: 1,
    all_employee: "all",
  };

  try {
    const response = await axios.get(route($route), {
      params: allData,
    });
    const providers = response.data.data;
    if (providers && providers.length > 0) {
      props.filterItem.dataProviders = providers.map((item) => {
        return {
          ...item,
          name: item.Name || item.name,
        };
      });
    }
  } catch (error) {
    console.error("Error fetching work sources profiles:", error);
  }
};

onMounted(async () => {
  if (
    props.filterItem.dataProviderTypes &&
    props.filterItem.dataProviderTypes.length == 0
  ) {
    await getDataProvierType();
  }
});
</script>